module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pl20 pr20"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 0),
      expression: "showDetail == 0"
    }],
    staticClass: "mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同账户信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-form', {
    ref: "supplier",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.supplier,
      "rules": _vm.rules,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "供应商id:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierId))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商编号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "供应商名称:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.supplier.supplierName))])])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.agreementList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cooperationTypeName",
      "label": "合作方式",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlementTypeName",
      "label": "结算方式",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contractCode",
      "label": "合同编号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountName",
      "label": "银行账户",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accountNumber",
      "label": "银行卡号",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "bankName",
      "label": "开户银行",
      "min-width": "200",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "更改日期",
      "min-width": "200",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("time")(scope.row.bankAccountUpdateTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.updateBankAccount(scope.row.id)
            }
          }
        }, [_vm._v("更改银行卡号")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.returnPage()
      }
    }
  }, [_vm._v("返回")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetail == 1),
      expression: "showDetail == 1"
    }],
    staticClass: "pl10 mt20"
  }, [_c('span', {
    staticClass: "dib"
  }, [_vm._v("合同账户信息")]), _c('span', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt20"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "结算方式："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreement.settlementTypeName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "合同编号："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.agreement.contractCode))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "更改银行卡："
    }
  }, [_c('el-select', {
    staticClass: "ml_10 vtb",
    attrs: {
      "placeholder": "请选择银行卡号"
    },
    model: {
      value: (_vm.agreement.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.agreement, "bankAccountId", $$v)
      },
      expression: "agreement.bankAccountId"
    }
  }, _vm._l((_vm.bankAccountList), function(val, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": val.name,
        "value": +val.id
      }
    })
  }))], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    staticClass: "mr10",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("保存")])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f6f4e3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/supplier/supplier_finance_edit.vue
// module id = 516
// module chunks = 0